import { Link } from 'react-router-dom';
import { getRankedComics, rankingMeta, type RankingType } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

interface Props {
  type: RankingType;
  accent?: boolean;
}

export default function RankingPreview({ type, accent = false }: Props) {
  const meta = rankingMeta[type];
  const list = getRankedComics(type).slice(0, 5);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="flex items-end justify-between">
        <div>
          <span className={`flex items-center gap-2 text-sm font-semibold ${accent ? 'text-accent-600' : 'text-primary-600'}`}>
            <i className={`${accent ? 'ri-medal-fill' : 'ri-fire-fill'} text-base`} />
            TOP 榜单
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{meta.label}</h2>
          <p className="mt-2 text-sm text-foreground-500">{meta.subtitle}</p>
        </div>
        <Link
          to={`/ranking/${type}`}
          className="flex shrink-0 items-center gap-1 rounded-full border border-background-200 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          查看完整榜单
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
        {list.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}